import { irReasonsSlice } from "./irReasonsSlice";
import * as actions from "./irReasonsActions";
import * as selectors from "./irReasonsSelectors";

export { actions };
export { selectors };
export default irReasonsSlice.reducer;
